import { createContext } from 'react';
import { ScrollStateValueType } from './types';

export const ScrollContext = createContext(undefined as unknown as ScrollStateValueType);
